module.exports = __webpack_public_path__ + "77a230140970142814fea88af3802772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-kirakira.png
// module id = 2092
// module chunks = 4